<template>
  <div>
    <div
      v-for="i in length"
      :key="i"
      class="skeleton"
    />
  </div>
</template>

<script>
export default {
  props: {
    length: {
      type: Number,
      default: 3,
    },
  },
};
</script>

<style scoped lang="scss">
  .skeleton {
    width: 100%;
    height: 250px;
    border-radius: 8px;
    margin-bottom: 24px;
    background-color: #F4F4F4;
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @keyframes pulse {
    50% {
      opacity: .5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/loading/jSkeletonComponent.vue